import _ from "lodash";
import { Store } from "../utils/Store";

import * as TrackingUtil from "../utils/TrackingUtil";
import ContentService from "../clients/ContentServiceClient";
import { SessionStore } from "../uidispatcherapi/SessionStore";

/**
 * HTML Snippets.
 */
class SnippetStoreImpl extends Store {
    snippets: {
        LEGAL_NOTICE: string | null | undefined;
        PRIVACY_STATEMENT: string | null | undefined;
        TERMS: string | null | undefined;
    };
    failed: boolean;
    loading: boolean;

    constructor() {
        super();
        this.failed = false;
        this.loading = true;
        this.snippets = { LEGAL_NOTICE: undefined, PRIVACY_STATEMENT: undefined, TERMS: undefined };
        this.loadSnippets();
    }

    loadSnippets() {
        this.loading = true;
        const locale = (window as any).lang;
        const country = SessionStore.getCountry();
        ContentService.getContent(country, locale)
            .then(resp => this.onGetSnippet(resp))
            .catch(error => this.onFailed(error));
    }

    onFailed(error: any) {
        this.loading = true;
        this.failed = true;
        TrackingUtil.trackUIError("SnippetStore", "Could not get snippets", error);
        this.trigger(this.snippets);
    }

    isFailed() {
        return this.failed;
    }

    isLoading() {
        return this.loading;
    }

    onGetSnippet(response: any) {
        try {
            const me: any = this;
            _.forEach(response, elem => {
                me.snippets[elem.type] = elem.html;
            });
            this.failed = false;
            this.loading = false;
        } catch (error) {
            this.onFailed(error);
            return;
        }

        this.trigger(this.snippets);
    }

    getSnippet(kind: "LEGAL_NOTICE" | "PRIVACY_STATEMENT" | "TERMS") {
        return this.snippets[kind];
    }
}

export default new SnippetStoreImpl();
